import TimeUtils from 'app/common/util/TimeUtils';
import AppContext from 'app/common/context/AppContext';
import { StyleSheet, Text, View } from '@react-pdf/renderer';
import React from 'react';

export const Footer = () => {
    const COPYRIGHT = 'Copyright © 2023 Eurocontrol-NM. All rights reserved.';
    const date = TimeUtils.formatDateDDMMYYYY(AppContext.getMonitoredDay());
    const created = `(created ${TimeUtils.formatDDHHMM(TimeUtils.NOW())})`;

    return (
        <View fixed style={styles.footer}>
            <Text style={styles.copyright}>{COPYRIGHT}</Text>
            <Text style={styles.date} render={({ pageNumber }) => `${date} ${created} Page #${pageNumber}`} />
        </View>
    );
};

const styles = StyleSheet.create({
    footer: {
        marginTop: 'auto',
        flexDirection: 'row',
        fontSize: 10,
        borderTop: '1px solid black',
    },
    copyright: {
        marginRight: 'auto',
    },
    date: {
        marginLeft: 'auto',
    },
});
